import BigTypo from './BigTypo.styled'

export default BigTypo
